import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import user from './user/reducer';
import upload from './upload/reducer';
import request from './request/reducer';
import request_detail from './request_detail/reducer';
import equipment_schedule_maintenance from './equipment_schedule_maintenance/reducer';
import search from './search/reducer';

const reducers = combineReducers({
  user,
  upload,
  menu,
  settings,
  authUser,
  request,
  request_detail,
  equipment_schedule_maintenance,
  search
});

export default reducers;
